import React from 'react';
import { Award, Wand2, BarChart3, Heart } from 'lucide-react';
import { WHY_US } from '../mock';

const ICON_MAP = { Award, Wand2, BarChart3, Heart };

export default function WhyUs() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <div className="text-[12px] uppercase tracking-[0.22em] text-[#162028]/60 mb-4 flex items-center gap-2">
              <span className="h-px w-8 bg-[#49001B]" /> Why Rabbit Box Ads?
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1] tracking-tight text-[#162028]">
              Where <span className="italic text-[#49001B]">creativity</span> meets measurable success.
            </h2>
          </div>
          <p className="lg:col-span-7 text-[16px] leading-[1.75] text-[#162028]/75">
            In the ever-evolving world of film and brand marketing, standing out is not just an option; it&rsquo;s a necessity. We blend the art of storytelling with the precision of strategic marketing to create campaigns that not only captivate but convert. Every campaign is a masterpiece designed to elevate your brand above the noise.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {WHY_US.map((w, i) => {
            const Icon = ICON_MAP[w.icon];
            return (
              <div key={i} className="group relative rounded-3xl border border-[#162028]/10 bg-[#ede2c4] p-8 md:p-10 hover:bg-[#162028] hover:text-[#ede2c4] transition-colors duration-500">
                <div className="flex items-start justify-between mb-6">
                  <div className="h-12 w-12 rounded-full border border-current/30 flex items-center justify-center group-hover:bg-[#49001B] group-hover:text-[#162028] group-hover:border-transparent transition-colors">
                    <Icon size={20} strokeWidth={1.7} />
                  </div>
                  <span className="text-[11px] font-mono opacity-50">0{i + 1}</span>
                </div>
                <h3 className="font-serif-display text-2xl md:text-[28px] leading-tight mb-3">{w.title}</h3>
                <p className="text-[14.5px] leading-relaxed opacity-80">{w.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
